import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);
const routes = [
  /////////////////////////    基本架构    /////////////////////////////////// 
  /////////////////////////// 客户端页面-开始 ///////////////////////////
  {
    path: "/client_login",
    meta: {
      system: "client"
    },
    component: () => import("./views/pages/client_side/login.vue"),
  },
  {
    path: "/client_index",
    meta: {
      system: "client"
    },
    component: () => import("./views/pages/client_side/client_index.vue"),
  },
  {
    path: "/client_Box",
    meta: {
      system: "client"
    },
    component: () => import("./views/pages/client_side/index.vue"),
  },
  {
    name: 'client_znx',
    path: "/client_znx",
    meta: {
      system: "client"
    },
    component: () => import("./views/pages/client_side/znx.vue"),
  },
  {
    name: "client_entrustList",
    path: "/client_entrustList",
    meta: {
      system: "client"
    },
    component: () => import("./views/pages/client_side/client_entrustList.vue"),
  },
  {
    name: "client_entrustEdit",
    path: "/pages/client_side/client_entrustEdit",
    meta: {
      system: "client"
    },
    component: () => import("./views/pages/client_side/client_entrustEdit.vue"),
  },
  /////////////////////////// 客户端页面-结束 ///////////////////////////
  {
    path: "/",
    component: () => import("./views/main.vue"),
  },
  // 系统管理--登录后台
  {
    path: "/login",
    component: () => import("./views/login.vue"),
  },

  // 首页
  {
    path: "/index",
    component: () => import("./views/main.vue"),
  },
  // 系统管理--登录后台
  {
    path: "/Syslogin",
    component: () => import("./views/pages/admin/Syslogin.vue"),
  },
  // 系统管理--系统主界面
  {
    path: "/Sysmain",
    component: () => import("./views/pages/admin/Sysmain.vue"),
  },

  // 系统管理--租户管理
  {
    path: "/pages/admin/sys/Systenant",
    component: () => import("./views/pages/admin/sys/Systenant.vue"),
  },
  // 系统管理--异常管理
  {
    path: "/pages/admin/sys/Syserror",
    component: () => import("./views/pages/admin/sys/Syserror.vue"),
  },

  // 404 页面
  {
    path: "/404",
    component: () => import("./views/404.vue"),
  },

  ///////////////////////////    合同客户账号  ////////////////////////////
  //客户台账
  {
    path: "/pages/customer/customer_list",
    component: () => import("./views/pages/customer/customer_list.vue"),
  },




  {
    path: "/pages/customer/wechat_user_list",
    component: () => import("./views/pages/customer/wechat_user_list.vue"),
  },

  // 报价功能
  {
    name: "quotation",
    path: "/pages/testing_manage/quotation/quotation",
    component: () => import('./views/pages/testing_manage/quotation/quotation.vue')
  },

  // 绩效台账
  {
    name: "performance_list",
    path: "/pages/kpi/performance_list",
    component: () => import('./views/pages/kpi/performance_list.vue')
  },

  // 月绩效台账
  {
    path: "/pages/kpi/month_performance_list",
    component: () => import('./views/pages/kpi/month_performance_list.vue')
  },

  // 劳务人员审核绩效台账
  {
    name: "laborPerson_kpi_list",
    path: "/pages/kpi/laborPerson_kpi_list",
    component: () => import('./views/pages/kpi/laborPerson_kpi_list.vue')
  },


  // 待审核台账
  {
    name: "waitpass_performance_list",
    path: "/pages/kpi/waitpass_performance_list",
    component: () => import('./views/pages/kpi/waitpass_performance_list.vue')
  },


  // 计时绩效台账
  {
    name: "timing_kpi",
    path: "/pages/kpi/timing_kpi",
    // path:"/pages/kpi/performance_list",
    component: () => import('./views/pages/kpi/timing_kpi.vue')
  },

  // 待审批计时绩效台账
  {
    name: "watpass_timing_kpi",
    // path:"/pages/kpi/waitpass_performance_list",
    path: "/pages/kpi/watpass_timing_kpi",
    component: () => import('./views/pages/kpi/watpass_timing_kpi.vue')
  },

  // 待审核试验台账
  {
    name: "watpass_experiment_kpi_list",
    // path:"/pages/kpi/waitpass_performance_list",
    path: "/pages/kpi/watpass_experiment_kpi_list",
    component: () => import('./views/pages/kpi/watpass_experiment_kpi_list.vue')
  },

  // 检测试验绩效台账
  {
    name: "my_experiment_kpi_list",
    // path:"/pages/kpi/waitpass_performance_list",
    path: "/pages/kpi/my_experiment_kpi_list",
    component: () => import('./views/pages/kpi/my_experiment_kpi_list.vue')
  },



  /////////////////////////    委托管理    ///////////////////////////////////
  {
    path: "/pages/testing_manage/engineering_list",
    component: () =>
      import("./views/pages/testing_manage/engineering_list.vue"),
  },


  {
    name: "upcome_list",
    path: "/pages/testing_manage/upcome_list",
    component: () => import("./views/pages/kpi/upcome_list.vue"),
  },

  //外检绩效批量申请
  {
    name: 'upcome_list',
    path: "/pages/kpi/externalBatchTesting",
    component: () => import("./views/pages/kpi/externalBatchTesting.vue"),
  },

  {
    name: 'upcome_list2',
    path: "/pages/kpi/externalBatchTesting2",
    component: () => import("./views/pages/kpi/externalBatchTesting2.vue"),
  },

  {
    name: 'externalBatchTesting3',
    path: "/pages/kpi/externalBatchTesting3",
    component: () => import("./views/pages/kpi/externalBatchTesting3.vue"),
  },


  {
    name: "entrust_list",
    path: "/pages/testing_manage/entrust_list",
    component: () => import("./views/pages/testing_manage/entrust_list.vue"),
    meta: {
      keepAlive: true
    }
  },
  {
    name: "entrustOnline_list",
    path: "/pages/testing_manage/entrustOnline_list",
    component: () => import("./views/pages/testing_manage/entrustOnline_list.vue"),
    meta: {
      keepAlive: true
    }
  },
  // 委托修改
  {
    name: "entrust_modify_list",
    path: "/pages/testing_manage/entrust_modify_list",
    component: () => import("./views/pages/testing_manage/entrust_modify_list.vue"),
  },
  {
    name: "entrust_discount_apply",
    path: "/pages/testing_manage/workflow/entrust_discount_apply",
    component: () => import("./views/pages/testing_manage/workflow/entrust_discount_apply.vue"),
  },
  {
    name: "entrust_reportsend_apply",
    path: "/pages/testing_manage/workflow/entrust_reportsend_apply",
    component: () => import("./views/pages/testing_manage/workflow/entrust_reportsend_apply.vue"),
  },

  //流程进度
  {
    name: "entrust_flow_list",
    path: "/pages/testing_manage/entrust_flow_list",
    component: () =>
      import("./views/pages/testing_manage/entrust_flow_list.vue"),
  },

  // //快递流程图
  // {
  //   name: "Delivery",
  //   path: "/pages/testing_manage/Delivery",
  //   component: () =>
  //     import("./views/pages/testing_manage/Delivery.vue"),
  // },

  {
    name: "entrust_edit",
    path: "/pages/testing_manage/entrust_edit",
    component: () => import("./views/pages/testing_manage/entrust_edit.vue"),
  },
  {
    name: "sample_stock_list",
    path: "/pages/testing_manage/sample_stock_list",
    component: () => import("./views/pages/testing_manage/sample_stock_list.vue"),
  },
  {
    name: "report_pass_list",
    path: "/pages/testing_manage/report_pass_list",
    component: () => import("./views/pages/testing_manage/report_pass_list.vue"),
    meta: {
      keepAlive: true
    }
  },
  {
    name: "report_manage_list",
    path: "/pages/testing_manage/report_manage_list",
    component: () => import("./views/pages/testing_manage/report_manage_list.vue"),
    meta: {
      keepAlive: true
    }
  },
  // 报告修改台账
  {
    name: "report_edit_apply_list",
    path: "/pages/testing_manage/report_edit_apply_list",
    component: () => import("./views/pages/testing_manage/report_edit_apply_list.vue"),
  },
  {
    name: "report_edit",
    path: "/pages/testing_manage/report_edit",
    component: () => import("./views/pages/testing_manage/report_edit.vue"),
  },
  {
    name: "report_towrite",
    path: "/pages/testing_manage/report_towrite",
    component: () => import("./views/pages/testing_manage/report_towrite.vue"),
  },
  {
    name: "report_editing",
    path: "/pages/testing_manage/report_editing",
    component: () => import("./views/pages/testing_manage/report_editing.vue"),
  },
  {
    name: "testing_list",
    path: "/pages/testing_manage/testing_list",
    component: () => import("./views/pages/testing_manage/testing_list.vue"),
    meta: {
      keepAlive: true
    }
  },
  {
    name: "testing_edit",
    path: "/pages/testing_manage/testing_edit",
    component: () => import("./views/pages/testing_manage/testing_edit.vue"),
  },
  // 批量检测
  {
    name: "batch_testing",
    path: "/pages/testing_manage/batch_testing",
    component: () => import("./views/pages/testing_manage/batch_testing.vue"),
  },
  {
    name: "testing_pass",
    path: "/pages/testing_manage/testing_pass",
    component: () => import("./views/pages/testing_manage/testing_pass.vue"),
  },
  {
    name: "testing_test_pass",
    path: "/pages/testing_manage/testing_test_pass",
    component: () => import("./views/pages/testing_manage/testing_test_pass.vue"),
  },
  {
    name: "testing_approval",
    path: "/pages/testing_manage/testing_approval",
    component: () => import("./views/pages/testing_manage/testing_approval.vue"),
  },
  //实验室管理
  {
    name: "laboratory_list",
    path: "/pages/testing_manage/laboratory_list",
    component: () => import("./views/pages/testing_manage/laboratory_list.vue"),
  },
  // 人脸设备管理
  {
    name: "facialdevices_list",
    path: "/pages/testing_manage/facialdevices_list",
    component: () => import("./views/pages/testing_manage/facialdevices_list.vue"),
  },

  // // 温湿度管理
  {
    name: "laboratory_testdata_list",
    path: "/pages/testing_manage/laboratory_testdata_list",
    component: () => import("./views/pages/testing_manage/laboratory_testdata_list.vue"),
  },


  // 生产厂家管理
  {
    name: "manufacturer_list",
    path: "/pages/testing_manage/basic/manufacturer_list",
    component: () => import("./views/pages/testing_manage/basic/manufacturer_list.vue"),
  },


  // 检测设备管理
  {
    name: "device_list",
    path: "/pages/devices_manage/device_list",
    component: () => import("./views/pages/devices_manage/device_manage.vue"),
  },

  {
    name: "device_list1",
    path: "/pages/devices_manage/device_list1",
    component: () => import("./views/pages/devices_manage/device_list1.vue"),
  },

  // 不合格台账管理
  {
    name: "unqualified_report_list",
    path: "/pages/testing_manage/unqualified_report_list",
    component: () => import("./views/pages/testing_manage/unqualified_report_list.vue"),
  },
  // 已存档报告台账管理
  {
    name: "keepedfiled_report_list",
    path: "/pages/testing_manage/keepedfiled_report_list",
    component: () => import("./views/pages/testing_manage/keepedfiled_report_list.vue"),
  },
  // 报告的全部数据(仅管理员可见)
  {
    name: "report_manage_full_list",
    path: "/pages/testing_manage/report_manage_full_list",
    component: () => import("./views/pages/testing_manage/report_manage_full_list.vue"),
  },
  // 报告批准台账
  {
    name: "report_approve_list",
    path: "/pages/testing_manage/report_approve_list",
    component: () => import("./views/pages/testing_manage/report_approve_list.vue"),
    meta: {
      keepAlive: true
    }
  },
  /////////////////////////    财务管理    ///////////////////////////////////
  // 合同管理
  {
    path: "/pages/cwgl/htgl",
    component: () => import("./views/pages/cwgl/htgl.vue"),
  },
  /////////////////////////    合同和财务管理    ///////////////////////////////////
  {
    path: "/pages/contract_manage/contract_list",
    component: () => import("./views/pages/contract_manage/contract_list.vue"),
  },
  {
    path: "/pages/contract_manage/contract_list_ywy",
    component: () => import("./views/pages/contract_manage/contract_list_ywy.vue"),
  },
  {
    path: "/pages/contract_manage/contract_review",
    component: () => import("./views/pages/contract_manage/contract_review.vue"),
  },
  {
    path: "/pages/contract_manage/contract_asr_list",
    component: () => import("./views/pages/contract_manage/contract_asr_list.vue"),
  },
  {
    path: "/pages/contract_manage/contract_asr_pass",
    component: () => import("./views/pages/contract_manage/contract_asr_pass.vue"),
  },
  {
    path: "/pages/contract_manage/bill_create",
    component: () => import("./views/pages/contract_manage/bill_create.vue"),
  },
  {
    path: "/pages/contract_manage/bill_edit",
    component: () => import("./views/pages/contract_manage/bill_edit.vue"),
  },
  {
    path: "/pages/contract_manage/bill_list",
    component: () => import("./views/pages/contract_manage/bill_list.vue"),
  },
  {
    path: "/pages/testing_manage/bankincome_list",
    component: () => import("./views/pages/testing_manage/bankincome_list.vue"),
  },
  {
    path: "/pages/testing_manage/bankincome_adopt",
    component: () => import("./views/pages/testing_manage/bankincome_adopt.vue"),
  },
  {
    path: "/pages/testing_manage/reportgrant_apply_list",
    component: () => import("./views/pages/testing_manage/reportgrant_apply_list.vue"),
  },
  // ======================  缴费记录登记APP 开始  =====================================
  {
    name: 'paylogs_list',
    path: "/pages/payLogsApp/payLogsList",
    component: () => import("./views/pages/payLogsApp/payLogsList.vue"),
  },
  // ======================  缴费记录登记APP 结束  =====================================

  // 手机端 批准
  {
    name: 'approve-list',
    path: "/pages/approve/approve-list",
    component: () => import("./views/pages/approve/approve-list.vue"),
  },
  {
    name: 'approve',
    path: "/pages/approve/approve",
    component: () => import("./views/pages/approve/approve.vue"),
  },

  //试验
  {
    name: 'experiment_list',
    path: "/pages/kpi/experiment_list",
    component: () => import("./views/pages/kpi/experiment_list.vue"),
  },

  //移动端平移
  {
    name: 'testing_transition',
    path: "/pages/kpi/testing_transition",
    component: () => import("./views/pages/kpi/testing_transition.vue"),
  },

  // 移动端 组出勤
  {
    name: 'attendance_list',
    path: "/pages/kpi/attendance_list",
    component: () => import("./views/pages/kpi/attendance_list.vue"),
  },
  //移动端 劳务人员
  {
    name: 'laborPerson_list',
    path: "/pages/kpi/laborPerson_list",
    component: () => import("./views/pages/kpi/laborPerson_list.vue"),
  },



  //移动端 劳务人员管理
  {
    name: 'laborPerson_listControl',
    path: "/pages/kpi/laborPerson_listControl",
    component: () => import("./views/pages/kpi/laborPerson_listControl.vue"),
  },


  // ======================  报告发放台账  =====================================
  {
    name: 'report_grant_list',
    path: "/pages/contract_manage/report_grant_list",
    component: () => import("./views/pages/contract_manage/report_grant_list.vue"),
  },
  // ======================  报告发放申请APP 开始  =====================================
  {
    name: 'report_grant_list_app',
    path: "/pages/reportGrantApplyApp/reportGrantApplyList",
    component: () => import("./views/pages/reportGrantApplyApp/reportGrantApplyList.vue"),
  },
  // ======================  报告发放申请APP 结束  =====================================
  // ======================  二维码收款台账 开始  =====================================
  {
    name: 'qrcodePayment_list',
    path: "/pages/testing_manage/qrcodePayment/qrcodePayment_list",
    component: () => import("./views/pages/testing_manage/qrcodePayment/qrcodePayment_list.vue"),
  },
  // ======================  二维码收款台账 结束  =====================================
  /////////////////////////    系统设置    ///////////////////////////////////
  // 资询管理-列表
  {
    name: "message_list",
    path: "/pages/system_settings/message_manage/message_list",
    component: () => import("./views/pages/system_settings/message_manage/message_list.vue"),
  },
  // 资询管理-新增、编辑
  {
    path: "/pages/system_settings/message_manage/message_edit",
    component: () => import("./views/pages/system_settings/message_manage/message_edit.vue"),
  },


  // 基础设置
  {
    path: "/pages/system_settings/basic_settings",
    component: () => import("./views/pages/system_settings/basic_settings.vue"),
  },

  // 
  {
    path: "/pages/system_settings/super_settings",
    component: () => import("./views/pages/system_settings/super_settings.vue"),
  },


  //不合格台账
  {
    path: "/pages/testing_manage/unqualified_report_list",
    component: () => import("./views/pages/testing_manage/unqualified_report_list.vue"),
  },
  //场所管理
  {
    name: "place_list",
    path: "/pages/testing_manage/place_list",
    component: () => import("./views/pages/testing_manage/place_list.vue"),
  },
  //共享文档管理
  {
    name: "sharedocument_list",
    path: "/pages/testing_manage/sharedocument_list",
    component: () => import("./views/pages/testing_manage/sharedocument_list.vue"),
  },
  // 附件下载记录
  {
    name: "downloadrecord_list",
    path: "/pages/testing_manage/downloadrecord_list",
    component: () => import("./views/pages/testing_manage/downloadrecord_list.vue"),
  },


  // 组织机构/机构管理
  {
    path: "/pages/system_settings/organization_manage",
    component: () =>
      import("./views/pages/system_settings/organization_manage.vue"),
  },

  /////////////////////////  检测组台账 //////////////////////////
  {
    name: "person_group",
    path: "/pages/system_settings/person_group",
    component: () => import('./views/pages/system_settings/person_group.vue')

  },

  //子公司管理
  {
    path: "/pages/system_settings/subcompany_list",
    component: () => import("./views/pages/system_settings/subcompany_list.vue"),
  },
  // 检测标准
  {
    path: "/pages/system_settings/test_standard",
    component: () => import("./views/pages/system_settings/test_standard.vue"),
  },
  // 检测参数
  {
    path: "/pages/system_settings/test_settings",
    component: () => import("./views/pages/system_settings/test_settings.vue"),
  },
  // 检测参考价格
  {
    name: "test_reference_price_list",
    path: "/pages/basic/test_reference_price_list",
    component: () =>
      import("./views/pages/basic/test_reference_price_list.vue"),
  },
  //设备使用台账
  {
    path: "/pages/devices_manage/device_userecord_list",
    component: () => import("./views/pages/devices_manage/device_userecord_list.vue"),
  },

  //短信发送记录
  {
    path: "/pages/system_settings/sms_record_list",
    component: () => import("./views/pages/system_settings/sms_record_list.vue"),
  },
  {
    path: "/pages/system_settings/sub/sms_record_list",
    component: () => import("./views/pages/system_settings/sub/sms_record_list.vue"),
  },
  //短信模板管理
  {
    path: "/pages/system_settings/sms_template_list",
    component: () => import("./views/pages/system_settings/sms_template_list.vue"),
  },
  // 工作流列表
  {
    name: "workflow_index",
    path: "/pages/workflow/workflow_index",
    component: () => import("./views/pages/workflow/workflow_index.vue"),
  },
  {
    name: "create-workflow",
    path: "/pages/workflow/create-workflow",
    component: () => import("./views/pages/workflow/create-workflow.vue"),
  },
  {
    name: "edit-workflow",
    path: "/pages/workflow/edit-workflow",
    component: () => import("./views/pages/workflow/edit-workflow.vue"),
  },
  {
    name: "my-todolist",
    path: "/pages/workflow/my-todolist",
    component: () => import("./views/pages/workflow/my-todolist.vue"),
  },
  // 可视化流程图
  {
    path: "/pages/workflow/super_flow/super_flow",
    component: () => import("./views/pages/workflow/super_flow/super_flow.vue"),
  },
  // 系统配置项目
  {
    path: "/configItem",
    path: "/pages/system_settings/sub/config_item",
    component: () => import("./views/pages/system_settings/sub/config_item.vue"),
  },
  // 企业微信中转页
  {
    path: "/cowechat",
    component: () => import("./views/cowechat.vue"),
  },
  // 移动端 外检委托列表
  {
    name: 'ext_inspect_list',
    path: "/pages/ext_inspect/ext_inspect_list",
    component: () => import('./views/pages/ext_inspect/ext_inspect_list.vue'),
  },
  // 外检委托
  {
    name: 'ext_inspect',
    path: "/pages/ext_inspect/ext_inspect",
    component: () => import('./views/pages/ext_inspect/ext_inspect.vue'),
  },
  // 外检任务列表
  {
    name: 'ext_task_list',
    path: "/pages/ext_inspect/ext_task_list",
    component: () => import('./views/pages/ext_inspect/ext_task_list.vue'),
  },
  // 创建任务
  {
    name: 'ext_task_creat',
    path: "/pages/ext_inspect/ext_task_creat",
    component: () => import('./views/pages/ext_inspect/ext_task_creat.vue'),
  },
  // 分配任务
  {
    name: 'ext_task_grant',
    path: "/pages/ext_inspect/ext_task_grant",
    component: () => import('./views/pages/ext_inspect/ext_task_grant.vue'),
  },
  // 外检委托 -- 移动端
  {
    name: 'ext_inspect_app',
    path: "/pages/ext_inspect/ext_inspect_app",
    component: () => import('./views/pages/ext_inspect/ext_inspect_app.vue'),
  },

  // 移动端外检委托 改版
  {
    name: 'tester_openEntrust',
    path: "/pages/ext_inspect/views/tester_openEntrust",
    component: () => import('./views/pages/ext_inspect/views/tester_openEntrust.vue'),
  },
  {
    name: 'out_entrust_list',
    meta: {
      system: "client"
    },
    path: "/pages/ext_inspect/views/out_entrust_list",
    component: () => import('./views/pages/ext_inspect/views/out_entrust_list.vue'),
  },
  {
    name: 'out_entrust_creat',
    meta: {
      system: "client"
    },
    path: "/pages/ext_inspect/views/out_entrust_creat",
    component: () => import('./views/pages/ext_inspect/views/out_entrust_creat.vue'),
  },
  {
    name: 'out_entrust_preview',
    meta: {
      system: "client"
    },
    path: "/pages/ext_inspect/views/out_entrust_preview",
    component: () => import('./views/pages/ext_inspect/views/out_entrust_preview.vue'),
  },
  // 移动端外检委托 改版 --- 结束
  // ================= 数据异常处理 =================
  {
    name: "error_list",
    path: "/pages/error_handle/error_list",
    component: () => import("./views/pages/error_handle/error_list.vue"),
    meta: {
      keepAlive: true
    }
  },
  // 委托修改
  {
    name: "entrust_err_edit",
    path: "/pages/error_handle/entrust_err_edit",
    component: () => import("./views/pages/error_handle/entrust_err_edit.vue"),
  },
  // 检测修改
  {
    name: "testing_err_edit",
    path: "/pages/error_handle/testing_err_edit",
    component: () => import("./views/pages/error_handle/testing_err_edit.vue"),
  },
  /////////////////////////    现场检测台账(外检)    ///////////////////////////////////
  {
    name: "outtesting_list",
    path: "/pages/testing_manage/outtesting_list",
    component: () => import("./views/pages/testing_manage/outtesting_list.vue"),
    meta: {
      keepAlive: true
    }
  },


  //外检绩效批量申请
  {
    name: 'externalBatchTesting',
    path: "/pages/kpi/externalBatchTesting",
    component: () => import("./views/pages/kpi/externalBatchTesting.vue"),
  },


];

const router = new VueRouter({
  mode: "history",
  // mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  //判读是后台系统还是 客户端系统 
  if (to.meta && to.meta.system == "client") {
    console.log(to.fullPath, '!!!to.fullPath!!!');
    next();
  } else {
    var uid = localStorage.getItem('masterKey');
    if (!uid) { //如果未登录
      if (to.path === '/login') { // 如果当前用户输入的是登录路由，那么就定向到 /choice_course 路由
        next()
      } else {
        if (to.fullPath.indexOf("/login") < 0) {
          localStorage.setItem("targetUrl", to.fullPath);
        }
        next('/login');
      }
    } else {
      next()
    }
  }

  if (from.path == '/' || from.path == '/login' || from.path == '/login/' && to.path == '/index') {
    // next('/pages/testing_manage/upcome_list')
    console.log(123456789);
  }
})




export default router;